import React,{Suspense} from "react";
import './Header.scss';
import SocialNetworks from "../components/SocialNetworks";
import Typical from 'react-typical';
import {Canvas} from 'react-three-fiber'
import Robot from '../components/Robot';
import { OrbitControls , PresentationControls } from '@react-three/drei';
import { useTranslation } from "react-i18next";

const Header = () =>{
    const [t, i18n] = useTranslation("global");
    return(
        <section className="Header" id="Header">
            <div className="wave wave1"></div>
            <div className="wave wave2"></div>
            <div className="wave wave3"></div>
            <div className="wave wave4"></div>
            <div className="Header-container">
                <div className="Hero">
                    <h1 className='Header-title'>{t("presentation")}</h1>
                    <h2 style={{color:'#B4B3B3'}}>
                        {" "}
                        {i18n.language === "es"? (
                            <Typical
                            loop={Infinity}
                            steps={[
                                "DESAROLLADOR FRONTEND 🔴 ",
                                1000,
                                "ESTUDIANTE DE SISTEMAS 💻 ",
                                1000,
                                "PROGRAMADOR WEB 🟢 ",
                                1000,
                            ]}
                        />):("")
                        }
                    </h2>
                    <h2>
                        {" "}
                        {
                            i18n.language === "es"? (""):(
                                <Typical
                                    loop={Infinity}
                                    steps={[
                                        "FRONTEND DEVELOPER 🔴 ",
                                        1000,
                                        "STUDENT IN SYSTEMS 💻 ",
                                        1000,
                                        "WEB PROGRAMMER 🟢 ",
                                        1000,
                                    ]}
                                />
                            )
                        }
                    </h2>
                    <SocialNetworks />
                    <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                        <Canvas style={{height:'400px'}}camera={{zoom:2 ,position:[8,10,15]}}>
                            <ambientLight intensity={0.5} />
                            <pointLight position={[35,35,0]} intensity={0.4} />
                            <pointLight position={[-35,35,0]} intensity={0.4} />
                            <Suspense fallback={null}>
                            <Robot />
                            </Suspense>
                        <OrbitControls enableZoom={false} enablePan={false} autoRotate autoRotateSpeed={5} />
                        <PresentationControls global={true} />
                    </Canvas>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Header;